/*
 *
 * SurveysImport reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_TEMPLATE_SURVEY_WATCHER,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_FAILED,
  UPLOAD_TEMPLATE_WATCHER,
  UPLOAD_TEMPLATE_SUCCESS,
  UPLOAD_TEMPLATE_FAILED,
  SAVE_TEMPLATE_WATCHER,
  SAVE_TEMPLATE_CEASED_WATCHER,
  SAVE_TEMPLATE_PROGRESS,
  SAVE_TEMPLATE_CEASED_PROGRESS,
  GET_SURVEY_SUMMARY_WATCHER,
  GET_SURVEY_SUMMARY_FAILED,
  GET_SURVEY_SUMMARY_SUCCESS,
} from "./constants"

export const initialState = fromJS({
  hasSummary: false,
  isDownloading: false,
  isUploading: false,
  percentage: 0,
  summaryData: {},
  isData: false,
  isLoading: false,
  surveyData: {},
})

function surveysImportReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TEMPLATE_SURVEY_WATCHER:
      return state.set("isDownloading", true)
    case GET_TEMPLATE_SUCCESS:
    case GET_TEMPLATE_FAILED:
      return state.set("isDownloading", false)

    case SAVE_TEMPLATE_WATCHER:
    case SAVE_TEMPLATE_CEASED_WATCHER:
      return state.set("percentage", 0)

    case SAVE_TEMPLATE_PROGRESS:
    case SAVE_TEMPLATE_CEASED_PROGRESS:
      return state.set("percentage", action.payload)

    case UPLOAD_TEMPLATE_WATCHER:
      return state.set("isUploading", true)
    case UPLOAD_TEMPLATE_SUCCESS:
      return state
        .set("isUploading", false)
        .set("hasSummary", true)
        .set("summaryData", action.payload)
    case UPLOAD_TEMPLATE_FAILED:
      return state.set("isUploading", false).set("hasSummary", false)

    case GET_SURVEY_SUMMARY_WATCHER:
      return state.set("isLoading", true)
    case GET_SURVEY_SUMMARY_SUCCESS:
      return state
        .set("isLoading", false)
        .set("isData", action.payload.isData)
        .set("surveyData", action.payload.surveyData)
    case GET_SURVEY_SUMMARY_FAILED:
      return state.set("isLoading", false).set("isData", false)

    default:
      return state
  }
}

export default surveysImportReducer
